/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind =
  {
    Approve: "approve",
    Burn: "burn",
    Mint: "mint",
    Transfer: "transfer",
  } as const;
export type CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind =
  ClosedEnum<
    typeof CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind
  >;

export type CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest =
  {
    ledgerCanisterId: string;
    includeKind?:
      | Array<
        CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind
      >
      | undefined;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$inboundSchema:
  z.ZodNativeEnum<
    typeof CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind
  > = z.nativeEnum(
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind,
  );

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$outboundSchema:
  z.ZodNativeEnum<
    typeof CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind
  > =
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$ {
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$inboundSchema` instead. */
  export const inboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$inboundSchema;
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$outboundSchema` instead. */
  export const outboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$outboundSchema;
}

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$inboundSchema:
  z.ZodType<
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    include_kind: z.array(
      CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$inboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "include_kind": "includeKind",
    });
  });

/** @internal */
export type CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$Outbound =
  {
    ledger_canister_id: string;
    include_kind?: Array<string> | undefined;
    start?: number | undefined;
    end?: number | undefined;
  };

/** @internal */
export const CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$outboundSchema:
  z.ZodType<
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$Outbound,
    z.ZodTypeDef,
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    includeKind: z.array(
      CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetIncludeKind$outboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      includeKind: "include_kind",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$ {
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$inboundSchema;
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$outboundSchema;
  /** @deprecated use `CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$Outbound` instead. */
  export type Outbound =
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$Outbound;
}

export function countTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequestToJSON(
  countTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest:
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest,
): string {
  return JSON.stringify(
    CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$outboundSchema
      .parse(
        countTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest,
      ),
  );
}

export function countTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest' from JSON`,
  );
}
